import { Box, Flex, useColorMode } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import Icon from "../../DSL/Icon/Icon";
import Link from "../../DSL/Link/Link";
import Marquee from "../../DSL/Marquee/Marquee";
import { lightOrDarkMode } from "../../DSL/Theme";
import Typography, { TVariant } from "../../DSL/Typography/Typography";
import FooterDrawer from "../../common/Footer/FooterDrawer";
import AppStore from "../../store/App.store";
import Header from "./Header";
import NavLinks from "./NavLinks";
import GuideOverlay from "../../components/SiteGuide/GuideOverlay";

interface AppLayoutProps {
  children?: any;
}

const AppLayout = observer(function AppLayout({ children }: AppLayoutProps) {
  return (
    <>
      <Flex flexDir={"column"} id={"react-modal-main"} minH={"100vh"} pb={"45px"}>
        {/* create space for our header rendered index.tsx */}
        <Box height={"40px"} />
        <Flex justifyContent={"center"} flexGrow={1} zIndex={1}>
          <Flex flexGrow={1} w={"full"} maxW={"8xl"} py={6} px={4} flexDirection={"column"}>
            <Header />
            <Flex grow={1}>{children}</Flex>
          </Flex>
        </Flex>
      </Flex>
      <FooterDrawer />
      <MobileNav />
      {AppStore.guide.isGuideActive && <GuideOverlay />}
    </>
  );
});

export const HeaderMarquee = () => {
  const { colorMode } = useColorMode();
  const linkColor = lightOrDarkMode(colorMode, "#FFD47D", "purple.50");
  return (
    <Box
      bg={lightOrDarkMode(colorMode, "#302D25", "purple.700")}
      borderBottom={"1px"}
      borderColor={lightOrDarkMode(colorMode, "black", "white")}
    >
      <Marquee speed={55} pauseOnHover>
        <Box px={4} py={2}>
          <Typography
            variant={TVariant.PresStart12}
            whiteSpace={"pre"}
            color={lightOrDarkMode(colorMode, "white", "white")}
          >
            Own the Doge{" "}
            <Link
              isExternal
              size={"sm"}
              color={linkColor}
              to={
                "https://swap.defillama.com/?chain=base&from=0x0000000000000000000000000000000000000000&to=0xAfb89a09D82FBDE58f18Ac6437B3fC81724e4dF6"
              }
            >
              Buy $DOG
            </Link>{" "}
            ... Own a piece of internet history{" "}
            <Link
              isExternal
              size={"sm"}
              color={linkColor}
              to={
                "https://swap.defillama.com/?chain=base&from=0x0000000000000000000000000000000000000000&to=0xAfb89a09D82FBDE58f18Ac6437B3fC81724e4dF6"
              }
            >
              Buy $DOG
            </Link>
            {" ... "} For very fun{" "}
            <Link
              isExternal
              size={"sm"}
              color={linkColor}
              to={
                "https://swap.defillama.com/?chain=base&from=0x0000000000000000000000000000000000000000&to=0xAfb89a09D82FBDE58f18Ac6437B3fC81724e4dF6"
              }
            >
              Buy $DOG
            </Link>
            {" ... "} For many wows{" "}
            <Link
              isExternal
              size={"sm"}
              color={linkColor}
              to={
                "https://swap.defillama.com/?chain=base&from=0x0000000000000000000000000000000000000000&to=0xAfb89a09D82FBDE58f18Ac6437B3fC81724e4dF6"
              }
            >
              Buy $DOG
            </Link>
            {" ... "}
            Own the Doge{" "}
            <Link
              isExternal
              size={"sm"}
              color={linkColor}
              to={
                "https://swap.defillama.com/?chain=base&from=0x0000000000000000000000000000000000000000&to=0xAfb89a09D82FBDE58f18Ac6437B3fC81724e4dF6"
              }
            >
              Buy $DOG
            </Link>
            {" ... "}
          </Typography>
        </Box>
      </Marquee>
    </Box>
  );
};

const MobileNav = observer(() => {
  const { colorMode } = useColorMode();
  useEffect(() => {
    const closeOnEsc = e => {
      if (e.key === "Escape") {
        if (AppStore.rwd.isMobileNavOpen) {
          AppStore.rwd.toggleMobileNav();
        }
      }
    };
    document.addEventListener("keydown", closeOnEsc);
    return () => {
      document.removeEventListener("keydown", closeOnEsc);
    };
  }, []);
  return (
    <AnimatePresence mode="wait">
      {AppStore.rwd.isMobileNavOpen && (
        <motion.div
          style={{
            display: "flex",
            position: "absolute",
            width: "100vw",
            height: "100vh",
            zIndex: 100,
            background: "transparent",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
          }}
          initial={{ left: -window.innerWidth }}
          animate={{ left: 0 }}
          exit={{ left: -window.innerWidth }}
          transition={{ duration: 0.25 }}
        >
          <Box
            opacity={0.9}
            position={"absolute"}
            w={"full"}
            h={"full"}
            bg={lightOrDarkMode(colorMode, "yellow.50", "purple.700")}
          />
          <Box zIndex={101}>
            <Flex flexDir={"column"} justifyContent={"center"} alignItems={"center"} gap={5}>
              <NavLinks
                onClick={() => {
                  if (AppStore.rwd.isMobileNavOpen) {
                    AppStore.rwd.toggleMobileNav();
                  }
                }}
                isMobile={AppStore.rwd.isMobile}
                size={"lg"}
              />
            </Flex>
            <Box position={"absolute"} top={5} right={5}>
              <Icon cursor={"pointer"} boxSize={35} icon={"close"} onClick={() => AppStore.rwd.toggleMobileNav()} />
            </Box>
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default AppLayout;
